import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import './DDCPlayerVideoComponent.scss';

const DDCPlayerVideoComponent = (props) => {
	const { video } = props;

	useEffect(() => {
		if (typeof DDC !== 'undefined' && document) {
			if (
				video &&
				DDC.modules &&
				DDC.modules.video &&
				typeof $ !== 'undefined'
			) {
				/* eslint no-undef: 0 */
				$(document).trigger('modulesRefresh', DDC.modules.video);
			}
		}
	}, [video]);

	if (video) {
		const {
			video: { id, uri },
			widgetInfo: { accountId, deviceType }
		} = props;

		const mobileOrientationIsPortrait =
			window?.DDC?.mobile?.orientation?.currentOrientation === 'portrait';

		let isPortrait = true;
		if (!mobileOrientationIsPortrait && /mobile/gi.test(deviceType)) {
			isPortrait = false;
		}

		const wrapperClassNames = [
			'h-100',
			'video-container',
			isPortrait ? 'portrait' : 'landscape'
		];
		const playerClassNames = ['h-100', 'ddcPlayer-holder'];
		const playerInfo = encodeURIComponent && encodeURIComponent(uri);
		return (
			<div className={wrapperClassNames.join(' ')}>
				{playerInfo && (
					<div
						id={`video-${id}`}
						className={playerClassNames.join(' ')}
						data-ddcplayerinfo={`${playerInfo}-1000-700`}
						data-accountid={`${accountId}`}
						data-useprepostroll="false"
						data-autoplay="false"
					/>
				)}
			</div>
		);
	}

	// No video - nothing to see here
	return null;
};
DDCPlayerVideoComponent.propTypes = {
	video: PropTypes.shape({
		uri: PropTypes.string
	})
};

DDCPlayerVideoComponent.propTypes = {
	widgetInfo: PropTypes.shape({
		accountId: PropTypes.string,
		deviceType: PropTypes.string
	}).isRequired,
	video: PropTypes.shape({
		id: PropTypes.number,
		uri: PropTypes.string
	})
};

DDCPlayerVideoComponent.defaultProps = {
	video: {}
};

export default DDCPlayerVideoComponent;
